import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function FixedHeader() {
  return {
    init: () => {
      const trigger = document.querySelector('header');

      gsap.to(trigger, {
        scrollTrigger: {
          trigger: trigger,
          start: 'top top',
          end: () => `+=${window.innerHeight * 0.5}`,
          onUpdate: (self) => {
            const progress = gsap.parseEase('power2.out')(self.progress);
            trigger.style.setProperty('--_progress', progress);
          },
          fastScrollEnd: true,
          scrub: true,
        },
      });
    },
  };
}
